/*************** hide shooter and/or sponsor registration forms on page load ***************/
jQuery(document).ready(function () {
	//get registration type value from localStorage
	//https://stackoverflow.com/questions/45626885/keep-dropdown-selected-after-refresh
	if ($('#input_7_1').length) {
		$('#input_7_1').val(localStorage.getItem('klays_registration_type'))
	}
	var selectedval = $('#input_7_1').val() // get selected value
	if (selectedval == 'Shooter') {
		$('.klays-registration-sponsor').hide()
	} else if (selectedval == 'Sponsor') {
		$('.klays-registration-shooter').hide()
	} else {
		$('.klays-registration-shooter').hide()
		$('.klays-registration-sponsor').hide()
	}
})

/*************** Show/Hide Forms based on select menu ***************/
$('#input_7_1').on('change', function () {
	// Save value in localstorage
	localStorage.setItem('klays_registration_type', $(this).val())
	var selectedval = $(this).val() // get selected value
	if (selectedval == 'Shooter') {
		$('.klays-registration-sponsor').hide()
		$('.klays-registration-shooter').slideDown()
	} else if (selectedval == 'Sponsor') {
		$('.klays-registration-shooter').hide()
		$('.klays-registration-sponsor').slideDown()
	} else {
		$('.klays-registration-shooter').hide()
		$('.klays-registration-sponsor').hide()
	}
	return false
})
